import { GetDataManagerNew, ApiCall, Query } from "../ds";
import { apiGet, apiPatch, apiPost } from "../helpers/apiHelper";
import get from "lodash/get";

const initialState = () => {
  return {
    cartUpdating: false,
    market: undefined,
    cart: undefined,
  };
};

export default {
  namespaced: true,

  state() {
    return initialState();
  },

  mutations: {
    setCartUpdating(state, status) {
      state.cartUpdating = status;
    },

    setMarket: (state, market) => {
      state.market = market;
    },

    setCart: (state, cart) => {
      state.cart = cart;
    },

    resetState(state) {
      Object.assign(state, initialState());
    },
  },

  actions: {
    async loadCart({ commit, state, rootState }) {
      const familyId = get(rootState, "connections.current.family.id", null);
      const marketId = get(state, "market.market.id", null);

      if (!familyId || !marketId) {
        return Promise.reject(new Error(`familyId or marketId missing`));
      }

      const response = await apiGet("family_market_current_cart", [
        familyId,
        marketId,
      ]);

      if (response && response.status === 200) {
        commit("setCart", response.data.payload);
        return response.data.payload;
      }
    },

    async setCartQuantity({ commit, state, rootState }, payload) {
      const familyId = get(rootState, "connections.current.family.id", null);
      const marketId = payload.marketId
        ? payload.marketId
        : get(state, "market.market.id", null);

      if (!familyId || !marketId) {
        return Promise.reject(new Error(`familyId or marketId missing`));
      }

      const ppms = get(payload, "items", []).map((el) => {
        return {
          ppm_id: parseInt(el.ppm_id, 10),
          qta: parseFloat(el.quantity),
        };
      });

      const params = { ppms };
      commit("setCartUpdating", true);

      const response = await apiPost("family_market_current_cart", params, [
        familyId,
        marketId,
      ]);

      if (response && response.status === 200) {
        commit("setCartUpdating", false);
        const cartData = response.data.payload;
        if (get(state, "market.market.id", null) === cartData.market) {
          commit("setCart", cartData);
        }
        return cartData;
      } else {
        commit("setCartUpdating", false);
        console.log(`Error updating marker cart`);
        console.error(response);
        return response;
      }
    },
  },
};
